import './SectionHeading.css';

function SectionHeading({ title, subtitle, id, children }) {
  return (
    <div className="section-heading">
      <h2 id={id}>{children || title}</h2>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
}

export default SectionHeading;
